<template>
  <div>
    <bg-section-video></bg-section-video>
  </div>
</template>

<script>
import BgSectionVideo from "@/components/bg-section-video";
export default {
  data() {
    return {
      data: {
        datasets: [{}],
      },
    };
  },
  components: { BgSectionVideo },
};
</script>
